import { render, staticRenderFns } from "./DashboardNoPageNoCredit.vue?vue&type=template&id=dc97d7cc"
import script from "./DashboardNoPageNoCredit.vue?vue&type=script&lang=js"
export * from "./DashboardNoPageNoCredit.vue?vue&type=script&lang=js"
import style0 from "./DashboardNoPageNoCredit.vue?vue&type=style&index=0&id=dc97d7cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports